import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    getTestRideEventSlots: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_TestRide_GetEventSlotList, data);
    },
    getBookingEventSlotTable: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_Booking_GetEventSlotTable, data);
    },
    getBookingEventSlots: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_Booking_GetEventSlotList, data);
    },
    getBookingEventSlotsTime: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_Booking_GetEventSlotTimeList, data);
    },
    confirmRegistration: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_Booking_Confirm, data);
    },
    cancelRegistration: (context, data) => {
        return Axios.post((<any>window).App.routes.TestRideEvent_Booking_Cancel, data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};